export const isSmallScreen = (size: string): boolean => {
  return size === "medium" || size === "small";
};
